import http from "./http";

function getDistributor2AgencyAllotReport(data) {
  return http.post(`distributorDeviceReport`, data);
}

function getDeviceInstallationReport(data) {
  return http.post(`installationReport`, data);
}

function getDevicelistforInstallation(data) {
  return http.post(`DeviceListforInstallation`, data);
}

function getvehiclerouteallotmentDetails(data) {
  return http.post(`vehicleRoutes_Details`, data);
}

function getDeviceStocksReports(data) {
  return http.post(`deviceStock_Report`, data);
}

function getAllotedvehiclereport(data) {
  return http.post(`uservehicleAssignList`, data);
}

function deleteAllotedvehicle(data) {
  return http.post(`Delete_Assignuser_toVehicle`, data);
}

function getVehiclewisePerformanceReport(data) {
  return http.post(`vehicle_performaneReport`, data);
}

function getDatewisePerformanceReport(data) {
  return http.post(`date_wisevehicle_performaneReport`, data);
}

function eventLog(data) {
  return http.post(`eventLog`, data);
}

function fetchGeofenceAlertReport(data) {
  return http.post(`Report_of_Alert`, data);
}

function fetch_esclationdata(data) {
  return http.post(`EscalationReport_for_vehicle`, data);
}

function pointOfIntrestReport(data) {
  return http.post("point_ofInterestReport", data);
}

const ReportService = {
  getDistributor2AgencyAllotReport,
  getDeviceInstallationReport,
  getDevicelistforInstallation,
  getvehiclerouteallotmentDetails,
  getDeviceStocksReports,
  getAllotedvehiclereport,
  deleteAllotedvehicle,
  getVehiclewisePerformanceReport,
  getDatewisePerformanceReport,
  eventLog,
  fetchGeofenceAlertReport,
  fetch_esclationdata,
  pointOfIntrestReport,
};

export default ReportService;
